import { regionCodes } from "common/static/regions";

import { getUserRegion } from "services/region";

import useCourseSectionsFetchState from "seneca-common/features/course/hooks/useCourseSectionsFetchState";
import { getCourseExamQuestionsCount } from "seneca-common/features/course/state";
import {
  useSelector,
  useSelectorOnConditionWithArgs
} from "seneca-common/utils/hooks/selectors";

import useCourseId from "features/classroom/routes/classroom/routes/course/hooks/useCourseId";

const EXAM_PREP_SUPPORTED_REGIONS = [
  regionCodes.GB,
  regionCodes.DE,
  regionCodes.FR,
  regionCodes.IT,
  regionCodes.BR,
  regionCodes.AU,
  regionCodes.ES
];

export function useShowExamPrep() {
  const courseId = useCourseId();
  const { coursesSectionsFinishedFetching } =
    useCourseSectionsFetchState(courseId);
  const examQuestionsCount = useSelectorOnConditionWithArgs(
    coursesSectionsFinishedFetching,
    getCourseExamQuestionsCount,
    courseId
  );

  const userRegion = useSelector(getUserRegion);

  return (
    !!examQuestionsCount && EXAM_PREP_SUPPORTED_REGIONS.includes(userRegion)
  );
}
